import * as React from 'react';
import { classes, st } from './ColorPicker.st.css';
import { ColorPickerBase } from './ColorPicker.base';
import { generateKey } from '../../common/random';
/** ColorPicker */
export class ColorPicker extends React.Component {
    constructor(props) {
        super(props);
        this._groupName = generateKey('ColorPicker_group');
    }
    render() {
        const { className, name, ...rest } = this.props;
        return (React.createElement(ColorPickerBase, { ...rest, name: name || this.props['aria-label'] || this._groupName, className: st(classes.root, className) }));
    }
}
ColorPicker.displayName = 'ColorPicker';
ColorPicker.Item = ColorPickerBase.Item;
//# sourceMappingURL=ColorPicker.js.map